<template lang="pug">
v-container.grid-list-xl
  v-layout(row wrap)
    v-flex(lg12 sm12 xs12)
      v-form.app-form(ref='form' lazy-validation @submit.prevent='onSubmit')
        v-card.app-card
          v-card-title.app-card-title(v-text="'Nova Viagem'")
          v-card-text.app-card-content
            v-row
              v-col(:md="12" :sm="12" :xs="12" cols="12" class="pb-0")
                h3.app-title-separate(v-text="'Detalhe da Viagem'")

              v-col(:md="6" :sm="6" :xs="12" cols="12")
                v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.license.nome"
                  type="text"
                  label="Origem *"
                  outlined
                  disabled
                )

              v-col(:md="6" :sm="6" :xs="12" cols="12" class="d-flex align-center pt-9 ")
                v-autocomplete(
                  :items="form.destino.items" 
                  :loading="form.destino.isLoading" 
                  :search-input.sync="searchDestino" 
                  v-model="form.destino.municipios"
                  prepend-inner-icon="search"
                  item-text="municipioNome"
                  label="Destino *"
                  autocomplete="off"
                  return-object
                  clearable
                  outlined
                  placeholder="Pesquise"
                  hide-no-data
                  hide-selected
                  :disabled="hasTravelActive"
                  :rules="[rules.required]"

                )
                
                template(v-slot:selection="{ attr, on, item }")
                    v-list-item
                      v-list-item-title(v-text="item")
              
                template(v-slot:item="{ item }")
                    v-list-item
                      v-list-item-title(v-text="item")

              v-col(:md="12" :sm="12" :xs="12" cols="12" class="pb-0 pt-0")
                h3.app-title-separate(v-text="'Passageiros'")

              v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.passageiro1"
                  type="text"
                  label="Passageiro *"
                  placeholder="Ex.: Joaozinho"
                  outlined
                  dense
                  :disabled="hasTravelActive"
                  :rules="[rules.required]"
                )

              v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.passageiro2"
                  type="text"
                  label="Passageiro"
                  placeholder="Ex.: Joaozinho"
                  outlined
                  dense
                  :disabled="hasTravelActive"
                )

              v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.passageiro3"
                  type="text"
                  label="Passageiro"
                  placeholder="Ex.: Joaozinho"
                  outlined
                  dense
                  :disabled="hasTravelActive"
                )

              v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.passageiro4"
                  type="text"
                  label="Passageiro"
                  placeholder="Ex.: Joaozinho"
                  outlined
                  dense
                  :disabled="hasTravelActive"
                )

              v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.passageiro5"
                  type="text"
                  label="Passageiro"
                  placeholder="Ex.: Joaozinho"
                  outlined
                  dense
                  :disabled="hasTravelActive"
                )

              v-col(:md="6" :sm="6" :xs="12" cols="12" )
                v-text-field(
                  v-model="form.passageiro6"
                  type="text"
                  label="Passageiro"
                  placeholder="Ex.: Joaozinho"
                  outlined
                  dense
                  :disabled="hasTravelActive"
                )
                

          v-divider
          v-card-actions
            v-spacer
            v-btn(depressed color="primary" :loading="loadingBtn" type="submit" :disabled="hasTravelActive || loadingBtn")
              span(v-text="'Iniciar Viagem'")
              .alert.alert-danger(v-if='error' v-text="error")
</template>

<script>
import { Subject, throwError } from "rxjs";
import {
  tap,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import MunicipiosService from "@/services/municipios.service";
import viagensService from "@/services/viagens.service";
import GlobalStore from "@/store/modules/global";
import { getLocation } from "@/util/geolocation";
import { cadastroViagemDB, municipiosDB } from "@/helpers/dexieDb";
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs";
export default {
  data: () => ({
    valid: true,
    form: {
      license: {
        municipioOrigemId: "",
        nome: "",
      },
      destino: {
        isLoading: false,
        items: [],
      },
      location: {
        latitude: "",
        longitude: "",
      },
      passageiro1: "",
      passageiro2: "",
      passageiro3: "",
      passageiro4: "",
      passageiro5: "",
      passageiro6: "",
    },
    model: {
      municipios: {},
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
    },
    searchOrigem: null,
    searchDestino: null,
    subjectOrigem: new Subject(),
    subjectDestino: new Subject(),
    error: "",
    loadingBtn: false,
  }),
  computed: {
    user: () => GlobalStore.user || {},
    ...mapState("viagens", ["hasTravelActive"]),
    ...mapState("viagens", ["pageRedirect"]),
  },
  watch: {
    searchOrigem(val) {
      if (val) {
        this.subjectOrigem.next(val);
      }
    },
    searchDestino(val) {
      if (val) {
        this.subjectDestino.next(val);
      }
    },
    pageRedirect: function () {
      this.backToTravelList();
    },
  },
  mounted() {
    this.citLicense();
    this.showPosition();
    this.municipiosDestino();
  },
  methods: {
    municipiosDestino() {
      this.subjectDestino
        .pipe(distinctUntilChanged())
        .pipe(tap(() => (this.form.destino.isLoading = true)))
        .pipe(debounceTime(1000))
        .pipe(switchMap((value) => MunicipiosService.find(value)))
        .subscribe(
          (result) => {
            const municipiosList = [];

            result.forEach((value) => {
              municipiosList.push({
                municipioDestinoId: value.id,
                municipioNome: value.nome,
              });
            });

            this.salvarMunicipiosStorage(municipiosList);
            this.form.destino.items = municipiosList;
            this.form.destino.isLoading = false;
          },
          (error) => {
            GlobalStore.setSnackBar({
              show: false,
              // message: "Ative sua localização",
              type: "success",
            });
            this.StorageMunicipios();
            this.form.destino.isLoading = false;
          }
        );
    },
    citLicense() {
      const { id, nome } = this.user.municipio;
      this.form.license.municipioOrigemId = id;
      this.form.license.nome = nome;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        const {
          license,
          destino,
          location,
          passageiro1,
          passageiro2,
          passageiro3,
          passageiro4,
          passageiro5,
          passageiro6,
        } = this.form;
        const passageiros = [
          { nome: passageiro1 },
          { nome: passageiro2 },
          { nome: passageiro3 },
          { nome: passageiro4 },
          { nome: passageiro5 },
          { nome: passageiro6 },
        ];

        const passageirosList = passageiros.filter((value) => {
          if (value.nome != "") {
            return value;
          }
        });

        const body = {
          latitude: location.latitude,
          longitude: location.longitude,
          municipioOrigemId: license.municipioOrigemId,
          municipioDestinoId: destino.municipios.municipioDestinoId,
          passageiroList: passageirosList,
          municipioOrigemNome: license.nome,
          municipioDestinoNome: destino.municipios.municipioNome,
          dataInicio: this.dateToday(),
        };
        this.saveTravelInitial(body);
        this.isLoading = false;
      }
    },
    backToTravelList() {
      this.$router.push({
        name: "my-trips",
      });
    },
    showPosition() {
      getLocation().subscribe(
        (res) => {
          this.form.location.latitude = res.latitude;
          this.form.location.longitude = res.longitude;
          this.verifyLocation(false);
        },
        (error) => {
          this.verifyLocation(true);
          GlobalStore.setSnackBar({
            show: true,
            message: "Ative sua localização",
            type: "error",
          });
        }
      );
    },
    async deletaViagemStorage() {
      await cadastroViagemDB.cadastroViagem.clear();
    },
    async salvarMunicipiosStorage(data) {
      let municipiosStorage = await municipiosDB.municipiosLista.toArray();
      if (municipiosStorage.length === 0) {
        municipiosDB.municipiosLista.bulkAdd([data]);
      } else {
        let verificaMunicipios = municipiosStorage.filter(function (
          value,
          index
        ) {
          return municipiosStorage.indexOf(value) === index;
        });

        await municipiosDB.municipiosLista.clear();
        municipiosDB.municipiosLista.bulkAdd(verificaMunicipios);
      }
    },
    async StorageMunicipios() {
      let municipiosStorage = await municipiosDB.municipiosLista.toArray();
      this.form.destino.items = municipiosStorage[0];
    },
    dateToday() {
      var dataHoraAtual = new Date();
      dataHoraAtual.setUTCHours(dataHoraAtual.getUTCHours());
      return dayjs(dataHoraAtual.toISOString()).format("YYYY-MM-DDTHH:mm:ss");
    },
    ...mapActions("viagens", { verifyLocation: "VERIFY_GEOLOCATION" }),
    ...mapActions("viagens", { saveTravelIndexDB: "SAVE_TRAVEL_INDEXDB" }),
    ...mapActions("viagens", { saveTravelInitial: "SAVE_TRAVEL_INITIAL" }),
  },
};
</script>

<style scoped></style>
